import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { WebhookRecordType } from 'src/types/webhook';

export interface TopBlockPropsType {
    data: WebhookRecordType | null;
    idWebhook: string | undefined;
    newWebhook: boolean;
    disableEdit: boolean;
    disableDelete: boolean;
    handleSave: () => void;
    handleDeleteWebhook: () => void;
    activeTab: string;
    onChangeTab: (value: string) => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const tabs = [
        { value: 'detail', label: translate('webhookDetail.detail') },
        { value: 'history', label: translate('webhookDetail.history'), hidden: props.newWebhook },
    ];

    return (
        <BodyTopBlock
            tabs={tabs}
            selectTab={!props.newWebhook ? props.activeTab : undefined}
            onChangeTab={!props.newWebhook ? props.onChangeTab : undefined}
            actions={[
                {
                    icon: <DeleteIcon />,
                    onClick: props.handleDeleteWebhook,
                    tooltip: translate('webhookDetail.deleteWebhook'),
                    hidden: props.disableDelete,
                    variant: 'outlined',
                },
                {
                    label: translate(props.newWebhook ? 'webhookDetail.create' : 'webhookDetail.save'),
                    onClick: props.handleSave,
                    hidden: props.disableEdit || props.activeTab !== 'detail',
                },
            ]}
        />
    );
};

export default TopBlock;
